import { render, staticRenderFns } from "./MiniDataTable.vue?vue&type=template&id=87c5d1e0&scoped=true&"
import script from "./MiniDataTable.vue?vue&type=script&lang=js&"
export * from "./MiniDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniDataTable.vue?vue&type=style&index=0&id=87c5d1e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c5d1e0",
  null
  
)

export default component.exports